import {
  Button,
  Card,
  Cell,
  CellGroup,
  Checkbox,
  CheckboxGroup,
  Collapse,
  CollapseItem,
  DatetimePicker,
  Dialog,
  Field,
  Icon,
  Info,
  Loading,
  NavBar,
  NoticeBar,
  Notify,
  NumberKeyboard,
  Panel,
  Picker,
  Radio,
  RadioGroup,
  Tab,
  Tabbar,
  TabbarItem,
  Tabs,
  Tag,
  Toast,
  Uploader,
  Divider,
  Popup,
  Pagination,
  Image,
  Empty,
  List,
  Badge
} from 'vant'
import 'vant/lib/index.css'
import 'vant/lib/icon/local.css'
import Vue from 'vue'

Vue.use(Button)
  .use(Card)
  .use(Cell)
  .use(CellGroup)
  .use(Checkbox)
  .use(CheckboxGroup)
  .use(Collapse)
  .use(CollapseItem)
  .use(DatetimePicker)
  .use(Dialog)
  .use(Field)
  .use(Icon)
  .use(Info)
  .use(Loading)
  .use(NavBar)
  .use(NoticeBar)
  .use(Notify)
  .use(NumberKeyboard)
  .use(Panel)
  .use(Picker)
  .use(Radio)
  .use(RadioGroup)
  .use(Tab)
  .use(Tabbar)
  .use(TabbarItem)
  .use(Tabs)
  .use(Tag)
  .use(Toast)
  .use(Uploader)
  .use(Divider)
  .use(Popup)
  .use(Pagination)
  .use(Image)
  .use(Empty)
  .use(List)
  .use(Badge)



// WEBPACK FOOTER //
// ./src/utils/vant.js